import React, { useState, Fragment, useEffect } from "react";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import { useHistory, useLocation } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

const AssessmentLetters = ({
  assessment,
  forceUpdate,
  time,
  setRestartKey,
  restartKey,
  setDone,
  setPlay,
  updateAssessmentResult,
  assessmentResults,
  deleteResult,
  clearResult,
  user,
  isAuthenticated,
  setValidationChecklist,
}) => {
  const hist = useHistory();
  const location = useLocation();
  const zeros = (arr) => {
    let r = [];
    for (let i = 0; i < arr.length; i++) {
      r.push(0);
    }
    return r;
  };
  const [letters, setLetters] = useState(
    assessmentResults.IncorrectIndex !== null
      ? () => {
          assessmentResults.IncorrectIndex.split(",");
          let temp = [];
          for (
            let i = 0;
            i < assessmentResults.IncorrectIndex.split(",").length;
            i++
          ) {
            temp[i] = parseInt(assessmentResults.IncorrectIndex.split(",")[i]);
          }
          return temp;
        }
      : zeros(assessment.Body.split(","))
  );
  const [values, setValues] = useState({
    wr:
      assessmentResults.WordReadNumber !== null
        ? assessmentResults.WordReadNumber
        : 0,
    errors:
      assessmentResults.ErrorNumber !== null
        ? assessmentResults.ErrorNumber
        : 0,
  });
  const [comment, SetComment] = useState(
    assessmentResults.Comment !== null ? assessmentResults.Comment : ""
  );

  const [CWPM, setCWPM] = useState(
    assessmentResults.CWPM !== null ? assessmentResults.CWPM : 0
  );

  const [totalScore, setTotalScore] = useState(
    assessmentResults.TotalScore !== null ? assessmentResults.TotalScore : 0
  );

  const [doneCurrent, setDoneCurrent] = useState(
    location.pathname.includes("/assessment/preview/")
  );

  const [showWarning, setShowWarning] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const validateEndMark = (results) => {
    if (results.includes(3)) {
      setValidationChecklist((prev) => {
        return prev?.map((item) => {
          if (item.desc === "Placed end mark") {
            return { ...item, checked: true };
          }
          return item;
        });
      });
    } else {
      setValidationChecklist((prev) => {
        return prev?.map((item) => {
          if (item.desc === "Placed end mark") {
            return { ...item, checked: false };
          }
          return item;
        });
      });
    }
  };

  const calculate = () => {
    // Test current Calculation
    console.log(CWPM, totalScore);

    let arr = [];
    let err = 0;
    console.log(letters);
    for (let i = 0; i < letters.length; i++) {
      if (letters[i] === 3) {
        break;
      }
      if (letters[i] === 1 || letters[i] === 4 || letters[i] === 5) {
        err++;
      }
      arr.push(letters[i]);
    }
    setValues({ wr: arr.length, errors: err });

    setCWPM(
      Math.round(
        Math.abs(values.wr - values.errors) / parseInt(assessment.Timer)
      )
    );

    // Old logic: Use percentage
    // setTotalScore(
    //   Math.round(((values.wr - values.errors) / letters.length) * 100),
    // );

    // New logic: Use CWPM
    setTotalScore(
      Math.round(
        Math.abs(values.wr - values.errors) / parseInt(assessment.Timer)
      )
    );
    forceUpdate();
    setRestartKey(restartKey + 1);
    setPlay(false);
    setDone(true);
    forceUpdate();
  };

  const onSubmit = (e) => {
    e.preventDefault();
    let data = {
      ...assessmentResults,
      IncorrectIndex: letters.join(","),
      WordReadNumber: parseInt(values.wr),
      ErrorNumber: parseInt(values.errors),
      CWPM: CWPM,
      CategoryID: assessment.CategoryID,
      Comment: comment,
      TotalScore: totalScore,
      CreatedDate: new Date().toISOString(),
    };

    // Validate if end mark added
    const endMarkAdded = letters.includes(3);

    if (!endMarkAdded) {
      setShowWarning(true);
      return;
    }
    setShowWarning(false);
    updateAssessmentResult(data).then(() => {
      hist.push(`/admin/result`);
    });
  };

  useEffect(() => {
    const isPreviewMode = location.pathname.includes("preview");

    // Case 1: Assessment done, not preview, values not calculated yet
    if (doneCurrent && !isPreviewMode && values.wr === 0) {
      calculate();
      return; // Early return to avoid executing other conditions
    }

    // Case 2: Values exist but scores not calculated yet
    if (values.wr !== 0 && totalScore === 0) {
      const calculatedScore = Math.round(
        Math.abs(values.wr - values.errors) / parseInt(assessment.Timer)
      );

      setCWPM(calculatedScore);
      setTotalScore(calculatedScore);

      forceUpdate();
      setRestartKey(restartKey + 1);
      setPlay(false);
      setDone(true);
      forceUpdate();
      return;
    }

    // Case 3: Assessment done, not preview, values already exist
    if (doneCurrent && !isPreviewMode && values.wr !== 0) {
      calculate();
    }
  }, [doneCurrent, values.wr, values.errors]);

  // Validation Task
  useEffect(() => {
    if (letters?.length) {
      validateEndMark(letters);
    }
  }, [letters]);

  return (
    <div className={`w-80  ${!isAuthenticated ? "mx-auto" : ""}`}>
      <div className="d-flex flex-wrap border border-2 bg-light py-4">
        {assessment.Body.split(",").map((letter, id) => {
          return (
            <div
              key={id}
              className="text-center my-3 cursor-pointer"
              style={{ width: 100 / assessment.Groups + "%" }}
            >
              {/* Click Trigger 
              - 0: No response
              - 1: Incorrect response
              - 2: Self Correction
              - 3: Skipped

              * No Click Trigger for End Mark
              Current letters[id]
              = 0: End mark/Time Out
              = 1: Incorrect response(error)
              = 2: Self Correction(no error)
              = 3: Skipped(error)
              = 5: Cancel
              */}
              <ContextMenuTrigger id={"same_unique_identifier" + id}>
                <b>
                  <div className="position-relative">
                    <span
                      onClick={() => {
                        if (isAuthenticated && !doneCurrent) {
                          const temp = [...letters];
                          if (letters[id] === 0) {
                            temp[id] = 1;
                          } else if (letters[id] === 1) {
                            temp[id] = 2;
                          } else if (letters[id] === 2) {
                            temp[id] = 4;
                          }

                          // Logic to move from 3 click skipped to end mark
                          // else if (letters[id] === 4) {
                          //    for (let i = 0; i < temp.length; i++) {
                          //     if (temp[i] === 3) {
                          //       temp[i] = 0;
                          //     }
                          //   }
                          //   temp[id] = 3;
                          // }
                          else {
                            temp[id] = 0;
                          }
                          setLetters(temp);
                          console.log(letters);
                        }
                      }}
                    >
                      {/* id=1 Incorrect */}
                      {letters[id] === 1 && (
                        <div
                          style={{
                            position: "absolute",
                            display: "inline-block",
                            bottom: "100%",
                            left: "0",
                          }}
                          className=" w-100"
                        >
                          <span className="incorrect px-1  d-inline-flex align-items-center justify-content-center">
                            <span>/</span>
                          </span>
                        </div>
                      )}

                      {/* id=2 Self Correct */}
                      {letters[id] === 2 && (
                        <div
                          style={{
                            position: "absolute",
                            display: "inline-block",
                            bottom: "100%",
                            left: "0",
                          }}
                          className=" w-100"
                        >
                          <span className="self-correct px-1 txt-primary d-inline-flex align-items-center justify-content-center">
                            SC
                          </span>
                        </div>
                      )}

                      {/* id=4 Skip */}
                      {letters[id] === 4 && (
                        <div
                          style={{
                            position: "absolute",
                            display: "inline-block",
                            bottom: "100%",
                            left: "0",
                          }}
                          className=" w-100"
                        >
                          <span className="skip px-1   d-inline-flex align-items-center justify-content-center">
                            <span>-</span>
                          </span>
                        </div>
                      )}

                      {/* id=3 End Mark */}
                      {letters[id] === 3 && (
                        <b style={{ color: "#FAA525" }}>]</b>
                      )}
                      <button className={"button-non"}>{letter}</button>
                    </span>
                  </div>
                </b>
              </ContextMenuTrigger>

              {/* Menu Context */}
              {isAuthenticated && !doneCurrent && (
                <ContextMenu
                  id={"same_unique_identifier" + id}
                  className="card react-contextmenu p-1"
                >
                          {/* id=3 End mark */}
                  <MenuItem
                    onClick={() => {
                      let temp = [...letters];
                      for (let i = 0; i < temp.length; i++) {
                        if (temp[i] === 3) {
                          temp[i] = 0;
                        }
                      }

                      temp[id] = 3;
                      setLetters(temp);
                    }}
                    className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                  >
                    <span
                      style={{ color: "#FAA525" }}
                      className="time-out px-1   d-inline-flex align-items-center justify-content-center"
                    >
                      <b> ]</b>
                    </span>
                    <span>
                      <b>End Mark</b>
                    </span>
                  </MenuItem>

                    {/* id=1 Incorrect */}
                  <MenuItem
                    onClick={() => {
                      let temp = [...letters];
                      temp[id] = 1;
                      setLetters(temp);
                    }}
                    className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                  >
                    <span className="incorrect px-1 d-flex align-items-center justify-content-center">
                      /
                    </span>
                    <span>
                      <b>Incorrect Response (error)</b>
                    </span>
                  </MenuItem>

                  {/* id=2 Self-Correct */}
                  <MenuItem
                    onClick={() => {
                      let temp = [...letters];
                      temp[id] = 2;
                      setLetters(temp);
                    }}
                    className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                  >
                    <span className="self-correct px-1 txt-primary d-inline-flex align-items-center justify-content-center">
                      SC
                    </span>
                    <span>
                      <b>Self Correction (no error)</b>
                    </span>
                  </MenuItem>

                  {/* id=4 Skipped */}
                  <MenuItem
                    onClick={() => {
                      let temp = [...letters];
                      temp[id] = 4;
                      setLetters(temp);
                    }}
                    className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                  >
                    <span className="skip px-1   d-inline-flex align-items-center justify-content-center">
                      -
                    </span>
                    <span>
                      <b>Skipped (error)</b>
                    </span>
                  </MenuItem>


                  {/* id=0 Cancel */}
                  <MenuItem
                    onClick={() => {
                      let temp = [...letters];
                      temp[id] = 0;
                      setLetters(temp);
                    }}
                    className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                  >
                    <span className="time-out px-1   d-inline-flex align-items-center justify-content-center"></span>
                    <span>
                      <b>Cancel</b>
                    </span>
                  </MenuItem>
                </ContextMenu>
              )}
            </div>
          );
        })}
      </div>
      {isAuthenticated && (
        <Fragment>
          <div class="form-floating my-2">
            <textarea
              onChange={(e) => SetComment(e.target.value)}
              class="form-control"
              placeholder="Leave a comment here"
              id="floatingTextarea2"
              value={comment}
              readOnly={location.pathname.includes("/assessment/preview/")}
              style={{ height: "100px" }}
            ></textarea>
            <label for="floatingTextarea2">Comments</label>
          </div>
          <div
            className={`d-flex align-items-center justify-content-${
              !doneCurrent ? "end" : "between"
            } my-3`}
          >
            {doneCurrent && (
              <div className="">
                Total Letters Read:{" "}
                <span className="txt-primary">
                  <b>{values.wr}</b>
                </span>{" "}
                , # of Errors:{" "}
                <span className="text-danger">
                  <b>{values.errors}</b>
                </span>{" "}
                CWPM:{" "}
                <span>
                  <b>{CWPM}</b>
                </span>{" "}
                Total Score:{" "}
                <span>
                  <b>{CWPM}</b>
                </span>
              </div>
            )}
            {!location.pathname.includes("/assessment/preview/") && (
              <div className="d-flex align-items-center justify-content-end mb-2  p-2">
                {doneCurrent && (
                  <button
                    type="reset"
                    className="button-primary btn-block btn px-5 mx-2"
                    onClick={() => {
                      // setLetters(zeros(assessment.Body.split(",")));
                      // setCWPM(0);
                      // setValues({
                      //   wr: 0,
                      //   errors: 0,
                      // });
                      // setTotalScore(0);
                      setDone(false);
                      setDoneCurrent(false);
                    }}
                  >
                    Edit
                  </button>
                )}
                {!doneCurrent && (
                  <button
                    type="reset"
                    className="button-primary btn-block btn px-5 mx-2"
                    onClick={() => {
                      setLetters(zeros(assessment.Body.split(",")));
                      setCWPM(0);
                      setValues({
                        wr: 0,
                        errors: 0,
                      });
                      setTotalScore(0);
                      setDone(false);
                      setDoneCurrent(false);
                    }}
                  >
                    Clear
                  </button>
                )}

                {!doneCurrent ? (
                  <button
                    className="button-primary btn-block btn px-5"
                    onClick={() => {
                      setDoneCurrent(true);
                      calculate();
                    }}
                  >
                    Save
                  </button>
                ) : (
                  <button
                    className="button-primary btn-block btn px-5"
                    onClick={(e) => onSubmit(e)}
                  >
                    Submit
                  </button>
                )}

                {/* Delete Modal */}
                <Modal
                  show={showDeleteModal}
                  onHide={() => setShowDeleteModal(false)}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Delete Assigned Assessment</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Are you sure you want to delete assigned assessment?
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setShowDeleteModal(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() => {
                        deleteResult(assessmentResults.ResultID, user.SchoolID);
                        hist.push("/admin/result");
                        clearResult();
                        setShowDeleteModal(false);
                      }}
                    >
                      Confirm
                    </Button>
                  </Modal.Footer>
                </Modal>

                {/* Delete Button */}
                <Button
                  variant="danger"
                  className="d-flex align-items-center px-4 mx-2"
                  onClick={() => setShowDeleteModal(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-trash-fill me-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                  </svg>
                  Delete
                </Button>

                {/* Warning Modal */}
                {/* ✅ Replace the Bootstrap modal with React Bootstrap Modal */}
                <Modal
                  show={showWarning}
                  onHide={() => setShowWarning(false)}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Submission Failed!</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Missing end mark! Please add an end mark (]) before
                    submitting.
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setShowWarning(false)}
                    >
                      OK, I'll add the end mark
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            )}
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default AssessmentLetters;
